import { __extends } from "tslib";
import { UpdateApnsSandboxChannelRequest, UpdateApnsSandboxChannelResponse } from "../models/models_1";
import { deserializeAws_restJson1UpdateApnsSandboxChannelCommand, serializeAws_restJson1UpdateApnsSandboxChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateApnsSandboxChannelCommand = /** @class */ (function (_super) {
    __extends(UpdateApnsSandboxChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateApnsSandboxChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateApnsSandboxChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "UpdateApnsSandboxChannelCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: UpdateApnsSandboxChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateApnsSandboxChannelResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateApnsSandboxChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateApnsSandboxChannelCommand(input, context);
    };
    UpdateApnsSandboxChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateApnsSandboxChannelCommand(output, context);
    };
    return UpdateApnsSandboxChannelCommand;
}($Command));
export { UpdateApnsSandboxChannelCommand };
//# sourceMappingURL=UpdateApnsSandboxChannelCommand.js.map